import { render, staticRenderFns } from "./News1.vue?vue&type=template&id=b46b2c48&scoped=true"
import script from "./News1.vue?vue&type=script&lang=js"
export * from "./News1.vue?vue&type=script&lang=js"
import style0 from "./News1.vue?vue&type=style&index=0&id=b46b2c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46b2c48",
  null
  
)

export default component.exports